import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import { Toaster } from '@/components/ui/sonner';

function App() {
  // Hide "Made with Emergent" badge
  useEffect(() => {
    const hideBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.style.display = 'none';
        badge.style.visibility = 'hidden';
        badge.style.opacity = '0';
        badge.style.pointerEvents = 'none';
      }
    };

    // Try immediately
    hideBadge();

    // Use MutationObserver to catch dynamically added badge
    const observer = new MutationObserver(() => {
      hideBadge();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also try after short delays in case of race conditions
    const timeouts = [100, 500, 1000, 2000].map(delay => 
      setTimeout(hideBadge, delay)
    );

    return () => {
      observer.disconnect();
      timeouts.forEach(clearTimeout);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;